import * as React from 'react';
import { Route, Routes } from 'react-router-dom';

import DevBasketContainer from '../../components/_dev/basket/DevBasketContainer';
import DevBasket from '../../components/_dev/DevBasket';
import TagUpdateContainer from '../TagUpdateContainer';
import DevEditTag from './../../components/_dev/DevEditTag';
import DevIndex from './../../components/_dev/DevIndex';
import withMainNavigation from './../withMainNavigation';

class DevContainer extends React.Component {
    public render() {
        return (
            <Routes>
                <Route path="/" element={<DevIndex />} />
                <Route path="edittag" element={<DevEditTag />} />
                <Route path="tag" element={<TagUpdateContainer />} />
                <Route path="basket" element={<DevBasket />} />
                <Route path="basket-basket" element={<DevBasketContainer />} />
            </Routes>
        );
    }
}

export default withMainNavigation(DevContainer);
